import React from "react";
import { Skeleton } from "@mui/material";
import moment from "moment";
import * as Styles from "./styles";

interface Props {
  dataUltimaAtualizacao: string | undefined;
  farolAtualizacao: "amarelo" | "verde" | "vermelho" | undefined;
}

export function AtualizadoBar(props: Props) {
  const [statusString, setStatusString] = React.useState<{
    text: string;
    color: string;
    backgroundColor: string;
  }>({ text: "--", color: "", backgroundColor: "" });

  React.useEffect(() => {
    if (props.dataUltimaAtualizacao) {
      const attDate = new Date(props.dataUltimaAtualizacao);
      const dateNow = new Date();
      const dateTime = props.dataUltimaAtualizacao?.split(" ");
      if (dateNow?.getDate() === attDate?.getDate()) {
        setStatusString({
          ...statusString,
          text: `Atualizado hoje, ${moment(attDate)?.format("DD/MM/YYYY")} às ${
            dateTime[1]
          }`,
        });
      } else {
        setStatusString({
          ...statusString,
          text: `Atualizado em ${moment(attDate)?.format("DD/MM/YYYY")} às ${
            dateTime[1]
          }`,
        });
      }
    }
  }, [props.dataUltimaAtualizacao]);

  React.useEffect(() => {
    switch (props.farolAtualizacao?.toLowerCase()) {
      case "amarelo":
        setStatusString({
          ...statusString,
          color: "#ED6C02",
          backgroundColor: "#FCE1CC",
        });
        break;
      case "verde":
        setStatusString({
          ...statusString,
          color: "#00a94c",
          backgroundColor: "#E8F9E8",
        });
        break;
      case "vermelho":
        setStatusString({
          ...statusString,
          color: "#f43636",
          backgroundColor: "#f4363620",
        });
        break;
      default:
        setStatusString({
          ...statusString,
          color: "#333333",
          backgroundColor: "#F5F5F5",
        });
    }
  }, [props.farolAtualizacao]);

  return (
    <>
      {props.dataUltimaAtualizacao ? (
        <>
          <Styles.TagTemperatura
            style={{
              backgroundColor: statusString.backgroundColor,
              color: statusString.color,
            }}
          >
            {statusString.text ?? "--"}
          </Styles.TagTemperatura>
        </>
      ) : (
        <>
          <Skeleton variant="rounded" width="auto" height="1.8125rem" />
        </>
      )}
    </>
  );
}
